import HelperDevelopment from "utils/helper-development";

if( !HelperDevelopment.isDev() ) {
	console.log = () => {
		return null;
	};
	console.time = () => {
		return null;
	};
	console.timeEnd = () => {
		return null;
	};
	console.prefix = ( prefix = '' ) => {
		return null;
	};
}else{
	const originalConsoleLog = console.log;
		console.prefix = function( prefix = '' ) {
		let args = [];

		args.push('[MOD]');

		if ( prefix.length > 0 ) {
			const today = new Date();
			const time = String(today.getHours()).padStart(2, '0') + ":" + String(today.getMinutes()).padStart(2, '0') + ":" + String(today.getSeconds()).padStart(2, '0');
			args.push( '[' + prefix + '][' + time + '] ' );
		}

		// Note: arguments is part of the prototype
		for ( let i = 1; i < arguments.length; i++ ) {
			args.push( arguments[ i ] );
		}

		originalConsoleLog.apply( console, args );
	};
	
	if( console.time === undefined ){
		console.time = () => {
			return null;
		};
	}
	
	if( console.timeEnd === undefined ){
		console.timeEnd = () => {
			return null;
		};
	}
}
